import { render, staticRenderFns } from "./DiscussionBoard.vue?vue&type=template&id=68292805&scoped=true"
import script from "./DiscussionBoard.vue?vue&type=script&lang=js"
export * from "./DiscussionBoard.vue?vue&type=script&lang=js"
import style0 from "./DiscussionBoard.vue?vue&type=style&index=0&id=68292805&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68292805",
  null
  
)

export default component.exports